import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Skeleton from "@mui/material/Skeleton";

import useMediaQueryScreen from "../../../hooks/useMediaQueryScreen";
import { useEffect, useRef, useState } from "react";
import PageWrapper from "../../../components/PageWrapper";

type Props = {};
const HEADER_ROW_HEIGHT = 75;
const SEARCHBAR_HEIGHT = 80;
const TABLE_ROW_HEIGHT = 75;
const PAGE_HEADER_HEIGHT = 112 + 64 + 80 + 64;
const CARD_PADDING = 32;

const RenderLoading = (props: Props) => {
  const { screen, screenProps } = useMediaQueryScreen();
  const divRef = useRef<HTMLDivElement | null>(null);

  const [height, setHeight] = useState<number>(0);

  const updateHeight = () => {
    if (divRef.current) {
      setHeight(divRef.current.offsetHeight);
    }
  };

  const getCountSkeletons = () => {
    if (height) {
      let possibleCells =
        (height -
          CARD_PADDING -
          HEADER_ROW_HEIGHT -
          SEARCHBAR_HEIGHT -
          PAGE_HEADER_HEIGHT) /
        TABLE_ROW_HEIGHT;

      return Math.floor(possibleCells);
    } else {
      return 11;
    }
  };

  useEffect(() => {
    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);
  return (
    <PageWrapper>
      <div className="card h-full" ref={divRef}>
        <div className="w-full h-28">
          <div className="row">
            <div className="col-12">
              <Skeleton variant="rectangular" width="15%" height={40} />
            </div>
            <div className="col-12 mt-5">
              <Skeleton variant="rectangular" width="100%" height={1} />
            </div>
          </div>
        </div>
        <div className="w-full  row justify-center">
          <div className="col-12 max-w-[1302px] row px-4">
            <div className="col-4 lg:col-6 row ">
              <Skeleton variant="rectangular" width="45%" height={80} />
            </div>
            <div className="col-8 lg:col-6 row gap-4 justify-end  items-center">
              <Skeleton variant="rectangular" width="60%" height={50} />
            </div>
          </div>
        </div>

        <div className="w-full mt-16 row justify-center items-start xl:p-4">
          <div className="col-12 row max-w-[1302px] xl:card" ref={divRef}>
            <div className="flex justify-between items-center col-12 mb-10">
              <Skeleton variant="rectangular" width="40%" height={40} />
              <Skeleton variant="rectangular" width="20%" height={40} />
            </div>
            <TableContainer>
              <Table>
                <TableHead className="bg-gray-200">
                  <TableRow>
                    <TableCell
                      sx={{
                        width: "450px",
                        height: "75px",
                      }}
                    >
                      <Skeleton variant="rectangular" width="85%" />
                    </TableCell>
                    <TableCell sx={{ width: "200px", height: "75px" }}>
                      <Skeleton variant="rectangular" width="85%" />
                    </TableCell>
                    {screenProps.is_largeplus ? (
                      <>
                        <TableCell sx={{ width: "200px", height: "75px" }}>
                          <Skeleton variant="rectangular" width="85%" />
                        </TableCell>
                        <TableCell sx={{ width: "200px", height: "75px" }}>
                          <Skeleton variant="rectangular" width="85%" />
                        </TableCell>
                      </>
                    ) : (
                      <></>
                    )}
                    <TableCell
                      sx={{
                        width: "200px",
                        height: "75px",
                      }}
                    >
                      <div className="flex justify-end">
                        <Skeleton variant="rectangular" width="85%" />
                      </div>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.from({ length: getCountSkeletons() }).map(
                    (_, index) => (
                      <TableRow
                        key={index}
                        className="hover:bg-gray-100"
                        sx={{ height: "75px" }}
                      >
                        <TableCell
                          sx={{
                            borderBottom:
                              index == getCountSkeletons() - 1 ? "none" : "",
                          }}
                        >
                          <Skeleton variant="rectangular" width="80%" />
                        </TableCell>
                        {screenProps.is_largeplus ? (
                          <>
                            <TableCell
                              sx={{
                                borderBottom:
                                  index == getCountSkeletons() - 1
                                    ? "none"
                                    : "",
                              }}
                            >
                              <Skeleton variant="rectangular" width="80%" />
                            </TableCell>
                            <TableCell
                              sx={{
                                borderBottom:
                                  index == getCountSkeletons() - 1
                                    ? "none"
                                    : "",
                              }}
                            >
                              <Skeleton variant="rectangular" width="80%" />
                            </TableCell>
                          </>
                        ) : (
                          <></>
                        )}
                        <TableCell
                          sx={{
                            borderBottom:
                              index == getCountSkeletons() - 1 ? "none" : "",
                          }}
                        >
                          <Skeleton variant="rectangular" width="80%" />
                        </TableCell>

                        <TableCell
                          sx={{
                            borderBottom:
                              index == getCountSkeletons() - 1 ? "none" : "",
                          }}
                        >
                          <div className="flex justify-end">
                            <Skeleton variant="rectangular" width="50%" />
                          </div>
                        </TableCell>
                      </TableRow>
                    )
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default RenderLoading;
